import type { KeysOfUnion } from "type-fest";

/**
 * Like `Object.keys` but typesafe.
 */
export const objectKeys = <T extends object>(obj: T) => Object.keys(obj) as Array<KeysOfUnion<T>>;


/**
 * Like `Object.entries` but typesafe.
 */
export const objectEntries = <T extends object>(obj: T) => Object.entries(obj) as Array<[KeysOfUnion<T>, ValuesOfUnion<T>]>;

export type ValuesOfUnion<T> = T extends unknown ? T[KeysOfUnion<T>] : never;
